import { render, staticRenderFns } from "./map-marker.vue?vue&type=template&id=810185fa&scoped=true&"
import script from "./map-marker.vue?vue&type=script&lang=js&"
export * from "./map-marker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810185fa",
  null
  
)

export default component.exports